import { PageFilterCard } from 'components/FilterCard';
import './styles.scss';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { ROUTE_MAP } from 'consts/url';
import { useMemo } from 'react';
import { ThuVienItemList } from './components/ThuVienItemList';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { SettingControl } from 'components/SettingControl';
import { useTranslation } from 'react-i18next';
import { usePageTracking } from 'hooks/usePageTracking';

// const makePaths = (size, arr) =>
//   arr.map((r) => `/assets/images/documents/${size}/${r}`);

const listItems = [
  // Hinh anh
  {
    id: 'img-1',
    thumb:
      'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'overview',
    content:
      'Phối cảnh tổng thể dự án Vision City nhìn từ trên cao với không gian xanh mát và thiết kế hiện đại.',
    type: 'hinh-anh',
  },
  {
    id: 'img-2',
    thumb:
      'https://images.unsplash.com/photo-1471039497385-b6d6ba609f9c?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'apartment',
    content:
      'Hình ảnh căn hộ mẫu với thiết kế nội thất sang trọng và tiện nghi hiện đại.',
    type: 'hinh-anh',
  },
  {
    id: 'img-3',
    thumb:
      'https://images.unsplash.com/photo-1601981125611-edb98122bf6a?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'amenity',
    content:
      'Hình ảnh tiện ích nội khu với hồ bơi, khu vui chơi và không gian xanh.',
    type: 'hinh-anh',
  },
  {
    id: 'img-4',
    thumb:
      'https://images.unsplash.com/photo-1763827657709-b1bbc3c4945b?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'living_room',
    content:
      'Hình ảnh phòng khách trong căn hộ mẫu với thiết kế hiện đại và ấm cúng.',
    type: 'hinh-anh',
  },

  // Video
  {
    id: 'vid-1',
    thumb:
      'https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?q=80&w=2674&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'SMART 3D Tour',
    video: 'https://www.youtube.com/watch?v=bqSY4MSvFc8',
    type: 'video',
  },
  {
    id: 'vid-2',
    thumb:
      'https://images.unsplash.com/photo-1550510537-89d5433de5cb?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    title: 'apartment',
    video: 'https://www.youtube.com/watch?v=bqSY4MSvFc8',
    type: 'video',
  },

  // Tai lieu
  {
    id: 'doc-1',
    thumb: '/assets/images/placeholder/pdf.jpg',
    configs: {
      name: 'Giới thiệu dự án Vision City',
      aspectRatio: 496 / 351,
      isPortrait: true,
      showCover: false,
      data: [
        '/assets/flipbook/horizontal/page-1.webp',
        '/assets/flipbook/horizontal/page-2.webp',
        '/assets/flipbook/horizontal/page-3.webp',
        '/assets/flipbook/horizontal/page-4.webp',
        '/assets/flipbook/horizontal/page-5.webp',
        '/assets/flipbook/horizontal/page-6.webp',
      ],
    },
    title: 'leaflet',
    content: 'Brochure dự án Vision City với thông tin chi tiết và hình ảnh.',
    type: 'tai-lieu',
  },
  {
    id: 'doc-2',
    thumb: '/assets/images/placeholder/pdf.jpg',
    configs: {
      name: 'Giới thiệu dự án Vision City',
      aspectRatio: 496 / 351,
      isPortrait: true,
      showCover: false,
      data: [
        '/assets/flipbook/horizontal/page-1.webp',
        '/assets/flipbook/horizontal/page-2.webp',
        '/assets/flipbook/horizontal/page-3.webp',
        '/assets/flipbook/horizontal/page-4.webp',
        '/assets/flipbook/horizontal/page-5.webp',
        '/assets/flipbook/horizontal/page-6.webp',
      ],
    },
    title: 'brochure',
    content: 'Brochure dự án Vision City với thông tin chi tiết và hình ảnh.',
    type: 'tai-lieu',
  },

  // Phap ly
  {
    id: 'legal-1',
    thumb: '/assets/images/placeholder/pdf.jpg',
    pdf: '/assets/pdf/1. QĐ 4055 Phe duyet dieu chinh 1-2000 P.16 Q.8 ngay 26.07.2013.pdf',
    title: 'legal_papers',
    content: 'Brochure dự án Vision City với thông tin chi tiết và hình ảnh.',
    type: 'phap-ly',
  },
  {
    id: 'legal-2',
    thumb: '/assets/images/placeholder/pdf.jpg',
    pdf: '/assets/pdf/2. QĐ 4151 Phe duyet ke hoach phat trien nha o 09.12.2021.pdf',
    title: 'construction_permit',
    content: 'Brochure dự án Vision City với thông tin chi tiết và hình ảnh.',
    type: 'phap-ly',
  },
];

const subMenus = [
  {
    id: 'hinh-anh',
    name: 'gallery',
    link: `/${ROUTE_MAP.library.id}/hinh-anh`,
  },
  { id: 'video', name: 'video', link: `/${ROUTE_MAP.library.id}/video` },
  {
    id: 'tai-lieu',
    name: 'document',
    link: `/${ROUTE_MAP.library.id}/tai-lieu`,
  },
  {
    id: 'phap-ly',
    name: 'legal_document',
    link: `/${ROUTE_MAP.library.id}/phap-ly`,
  },
];

const titleAdapter = {
  'hinh-anh': 'gallery',
  video: 'video',
  'tai-lieu': 'document',
  'phap-ly': 'legal_document',
};

const ThuVienPage = (props) => {
  const { t } = useTranslation();
  const { typeId } = props.match.params;
  usePageTracking(typeId ? `library-${typeId}` : 'library');

  const items = useMemo(() => {
    if (!typeId) return listItems;
    return listItems.filter((item) => item.type === typeId);
  }, [typeId]);

  return (
    <PerfectScrollbar className="thu-vien-page">
      <h2>{typeId ? t(titleAdapter[typeId]) : t('library')}</h2>
      <PageFilterCard className="thu-vien-filter-card">
        <div className="item-list">
          {subMenus.map((menu) => (
            <Link to={menu.link} key={menu.id}>
              <div className={`item ${typeId === menu.id ? 'active' : ''}`}>
                {t(menu.name)}
              </div>
            </Link>
          ))}
        </div>
      </PageFilterCard>
      <ThuVienItemList items={items} />
      <SettingControl />
    </PerfectScrollbar>
  );
};

export default ThuVienPage;
